import React, { FunctionComponent } from "react";
import { Albums, IAlbumsPageProps } from "./component";

export const AlbumsContainer: FunctionComponent<IAlbumsPageProps> = ({
  isPublic,
  onPlayFromYouTube
}) => {
  return <Albums isPublic={isPublic} onPlayFromYouTube={onPlayFromYouTube} />;
};
